import React, { useEffect } from 'react';
import { useRouter } from 'next/router';
import { useRecoilValue } from 'recoil';
import styled from 'styled-components';

import useModal from '@/hooks/useModal';
import useToast from '@/hooks/useToast';
import { isLoginState, loginState } from '@/recoil';
import DividerDefault from '@/components/Divider/Default';
import SvgSelector from '@/components/Svg/SvgSelector';
import AccuseModal from '@/containers/modal/InA/AccuseModal';
import { UpdateHeartCount } from '@/queries/ina/detail/updateHeartCount';
import { LocalStorage } from '@/utils/LocalStorage';
import StringUtil from '@/utils/StringUtil';
import { FontStyle } from '@/utils/StyleUtil';
import { IAnswer } from '@/models/ina';

interface IProps {
    item: IAnswer;
}

const StatusPart = ({ item }: IProps) => {
    const router = useRouter();
    const { addModal, removeCurrentModal } = useModal();
    const { openToast } = useToast();
    const isLogin = useRecoilValue(isLoginState);
    const { clientId } = useRecoilValue(loginState);
    const { likeAnswer, unlikeAnswer } = UpdateHeartCount(item.id);
    const isClickHeart = item.likes.includes(clientId);
    const heartCnt = item.likes.length;

    const controlHeart = async () => {
        if (isClickHeart) unlikeAnswer({});
        else likeAnswer({});
    };

    useEffect(() => {
        const handleReplace = () => {
            const scrollY = LocalStorage.getItem('InA-detail-y-position');

            if (scrollY) {
                window.scrollTo(0, Number(scrollY));
                LocalStorage.removeItem('InA-detail-y-position');
            }
        };

        router.events.on('routeChangeComplete', handleReplace);

        return () => {
            router.events.off('routeChangeComplete', handleReplace);
        };
    }, []);

    return (
        <StatusContainer>
            <AnswerInfoContainer>
                <span
                    className="heart"
                    onClick={() => {
                        if (isLogin && item.plannerSummary) controlHeart();
                        else if (!isLogin) openToast('로그인을 하신 후 이용해주세요');
                    }}
                >
                    <SvgSelector
                        svg="heart"
                        width={16}
                        height={15}
                        stroke={isClickHeart ? '#f54040' : '#acacac'}
                        fill={isClickHeart ? '#f54040' : '#acacac'}
                    />
                </span>
                <div className="like_cnt">{heartCnt}</div>
                {/*<DividerDefault direction="vertical" thickness={1} length="8px" color="#f1f1f1" margin="0 8px" />*/}
            </AnswerInfoContainer>
            <RightSide>
                <CreatedAt className="created_at">{StringUtil.displayedAt(item.createdAt)}</CreatedAt>
                <div
                    onClick={() => {
                        addModal({
                            key: 'slide',
                            props: {
                                content: <AccuseModal contentType={2} contentId={item.id} />,
                                handleCloseModal: removeCurrentModal,
                            },
                        });
                    }}
                >
                    <SvgSelector svg="more-vert" width={20} height={20} stroke="#ACACAC" />
                </div>
            </RightSide>
        </StatusContainer>
    );
};

const StatusContainer = styled.div`
    display: flex;
    ${({ theme }) => theme.flex.justifyBetween};
    margin-top: 16px;
`;

const RightSide = styled.div`
    display: flex;
    gap: 2px;
`;

const CreatedAt = styled.div`
    ${FontStyle(12, 20, '400', '#ACACAC', -1)};
`;

const AnswerInfoContainer = styled.div`
    ${({ theme }) => theme.flex.flexOnly};
    align-items: center;

    .heart {
        padding-top: 2px;
    }
    .like_cnt {
        margin-left: 2px;
        ${FontStyle(14, 22, '400', '#acacac', -1)};
    }
    .created_at {
        ${FontStyle(12, 20, '400', '#c8c8c8', -1)};
    }
`;

export default StatusPart;
